export const POSITION = {
  START: 0,
  END: 1
};

export const currencySymbols = {
  "ر.س": POSITION.END,
  "%": POSITION.END
};

export function currencyPosition(number, currency) {
  if (currency !== undefined) {
    if (currencySymbols[currency] === POSITION.END) {
      return number + currency;
    } else {
      return currency + number;
    }
  } else {
    return number;
  }
}
